export class JwtAuthConnectionError extends Error {

    constructor(message: string) {
        super(message);

        // because we are extending a built-in class
        Object.setPrototypeOf(this, JwtAuthConnectionError.prototype);
    }

    getErrorMessage() {
        return 'Something went wrong: ' + this.message;
    }
}
